<div class="modal-header">
  <h4 class="modal-title">Session Expired</h4>
</div>
<div class="modal-body">
  <p>Do you want to resume the session?</p>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger"
    (click)="onActionTrigger('logout')"
  >
    Logout (<span id="clockdiv"></span>)
  </button>
  <button
    type="button"
    ngbAutofocus
    class="btn btn-outline-secondary"
    (click)="onActionTrigger('resume')"
  >
    Yes,Resume
  </button>
</div>
